import Splide from '@splidejs/splide';

const EL = document.querySelector('.js-LookbookCarousel')

if(EL){
  const splide = new Splide( EL, {
    pagination: true,
  } ).mount();
}
